import SimpleCMP from '@components/SimpleCMP';
import { FooterV2 } from '@layouts/FooterV2';
import RenderIf from '@utils/renderIf';

import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React from 'react';

import Seo from './Seo';

const Layout = ({ children, title, description, useTitleTemplate = 'Traqq', additionalMetaTags, defaultSeoConfig }) => {
  const { pathname } = useRouter();
  
  return (
    <>
      <SimpleCMP/>
      <Seo
        title={title}
        description={description}
        useTitleTemplate={useTitleTemplate}
        additionalMetaTags={additionalMetaTags}
        defaultSeoConfig={defaultSeoConfig}
      />
      
      {children}
      
      {/*<RenderIf
                isTrue={ ['pricing'].some(item => pathname.includes(item)) }
            >
                <GetOnTraqqLayout/>
            </RenderIf>*/}
      
      <RenderIf
        isTrue={!['404', '500', '400', '401', '403', '502', '503', '504', 'action-forbidden', 'land/enterprise-time-tracking', 'land/time-tracking-solution', 'land/effective-time-tracker'].some(item => pathname.includes(item))}
      >
        <FooterV2/>
      </RenderIf>
      
      {/*<CookieAccept/>*/}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node,
  defaultSeoConfig: PropTypes.object,
  description: PropTypes.string,
  title: PropTypes.string,
  useTitleTemplate: PropTypes.string
};

export default Layout;
